import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _objectSpread from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { Ge as y, hi as h, D as f, T as P, bo as u, di as k, M as w, fi as z } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as p } from "./state-b4c9cc73-ee633f6c.js";
import { i as g } from "./query-24926cff-3eb94bfb.js";
import { d as S } from "./unsafe-svg-8b07bc77-f986d223.js";
import { d as m } from "./conditionalClasses-ab015858-46904105.js";
import { A as v } from "./query-assigned-ba663908-228b08f4.js";
import "./directive-daf4e9b6-abc0af54.js";
var x = "<svg width=\"33\" height=\"32\" viewBox=\"0 0 33 32\" slot=\"icon\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" class=\"play-icon\">\n<path d=\"M32 16L8 29.8564L8 2.14359L32 16Z\"  stroke-width=\"2\" stroke-linejoin=\"round\"/>\n</svg>",
  s = {
    beaconTagName: "beacon-video",
    brightcovePlayerBaseURL: "https://players.brightcove.net/",
    brightcovePlayerScriptURL: "/default_default/index.min.js",
    brightcovePlayerScriptID: "beacon-video-player-script",
    get brightcovePlaylistScriptURL() {
      return "".concat(this.brightcovePlayerBaseURL, "videojs-bc-playlist-ui/3/videojs-bc-playlist-ui.min.js");
    },
    brightcoverPlaylistScriptID: "beacon-video-playlist-script",
    hiddenClass: "hidden",
    videoClass: "beacon-video-player",
    beaconNestedComponents: ["beacon-icon-button"]
  },
  l = _objectSpread({}, s, {
    appendTag: "script"
  });
var d = /*#__PURE__*/function () {
  function d() {
    _classCallCheck(this, d);
  }
  _createClass(d, null, [{
    key: "buildPlayerScriptURL",
    /**
     * Takes an input account num sourced from a Brightcove video player and constructs the script tag url source necessary to append to the DOM
     * @param brightcovePlayerBaseURL - A String of the base brightcove URL https://players.brightcove.net/, overriden for test purposes
     * @param brightcovePlayerScriptURL - A String of the URL location of the video-js player Brightcove script /default_default/index.min.js.
     * @param accountNum - a string representation of the `<video-js>`'s data-account attribute
     * @returns a url in the following format https://players.brightcove.net/${accountNum}/default_default/index.min.js
     */
    value: function buildPlayerScriptURL(_ref) {
      var _ref$brightcoveBaseUR = _ref.brightcoveBaseURL,
        e = _ref$brightcoveBaseUR === void 0 ? l.brightcovePlayerBaseURL : _ref$brightcoveBaseUR,
        _ref$brightcoveScript = _ref.brightcoveScriptURL,
        t = _ref$brightcoveScript === void 0 ? l.brightcovePlayerScriptURL : _ref$brightcoveScript,
        _ref$accountNum = _ref.accountNum,
        a = _ref$accountNum === void 0 ? "0" : _ref$accountNum;
      return "".concat(e).concat(a).concat(t);
    }
    /**
     * Formats an input video duration in seconds to a trimmed hh:mm:ss format
     * @param seconds a Brightcove player object's .duration() result as a number
     * @returns A 0 trimmed string representation of the input seconds in hh:mm:ss format
     */
  }, {
    key: "formatDuration",
    value: function formatDuration(e) {
      var t = Math.floor(e / 3600),
        a = Math.floor(e % 3600 / 60),
        n = Math.floor(e % 60);
      var o = "";
      t > 0 && (o += "".concat(t, ":"));
      var c = "".concat(a);
      return t > 0 && a === 0 && (c = "00"), o += "".concat(c, ":").concat(n < 10 ? "0" : "").concat(n), o;
    }
    /**
     * Appends a `<script>` tag to the document body with the specified src and id attributes
     * @param url the url used for the script's src attribute
     * @param id the id used for the script's id attribute
     * @returns A Promise that resolves after the script's load event fires.
     */
  }, {
    key: "appendScriptWithURL",
    value: function appendScriptWithURL(e, t) {
      return new Promise(function (a, n) {
        var o = document.createElement(l.appendTag);
        o.setAttribute("id", t), o.setAttribute("src", e), o.onload = function () {
          return a();
        }, o.onerror = function () {
          return n(new Error("Failed to load Video Player Script"));
        }, document.body.appendChild(o);
      });
    }
    /**
     * Uses appendScriptWithURL to append the Brightcove Playlist's script tag to the DOM and awaits the associated load event
     * @param object Optional object containing the default URL of the Brightcove playlist script and Const ID
     */
  }, {
    key: "appendPlaylistScript",
    value: function () {
      var _appendPlaylistScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
        var _ref2$url, e, _ref2$id, t;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref2$url = _ref2.url, e = _ref2$url === void 0 ? l.brightcovePlaylistScriptURL : _ref2$url, _ref2$id = _ref2.id, t = _ref2$id === void 0 ? l.brightcovePlaylistScriptURL : _ref2$id;
              _context.t0 = document.getElementById(t);
              if (_context.t0) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return d.appendScriptWithURL(e, t);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function appendPlaylistScript(_x) {
        return _appendPlaylistScript.apply(this, arguments);
      }
      return appendPlaylistScript;
    }()
    /**
     * Uses appendScriptWithURL to append the Brightcove Player's script tag to the DOM and awaits the associated load event
     * @param object Optional object containing the default URL of the Brightcove player script and Const ID
     */
  }, {
    key: "appendPlayerScript",
    value: function () {
      var _appendPlayerScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
        var _ref3$id, e, _ref3$accountNum, t, a;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref3$id = _ref3.id, e = _ref3$id === void 0 ? l.brightcovePlayerScriptID : _ref3$id, _ref3$accountNum = _ref3.accountNum, t = _ref3$accountNum === void 0 ? "0" : _ref3$accountNum;
              if (document.getElementById(e)) {
                _context2.next = 5;
                break;
              }
              a = d.buildPlayerScriptURL({
                accountNum: t
              });
              _context2.next = 5;
              return d.appendScriptWithURL(a, e);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function appendPlayerScript(_x2) {
        return _appendPlayerScript.apply(this, arguments);
      }
      return appendPlayerScript;
    }()
  }]);
  return d;
}();
var L = y(_templateObject || (_templateObject = _taggedTemplateLiteral([".beacon-video-player .vjs-big-play-button{display:none}.beacon-video-player .vjs-poster{box-shadow:inset 0 0 0 100vw rgba(var(--beacon-color-overlay),.38)}.beacon-video-player .vjs-play-progress,.beacon-video-player .vjs-volume-level{background-color:var(--beacon-color-cta-primary-default)}\n"]))),
  j = y(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([":host{--video-overlay-column-span: 1/2;--overlay-z-index: 1;display:grid;grid-template-columns:auto;grid-template-rows:auto;inline-size:100%}::slotted(video-js.beacon-video-player){grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);inline-size:100%}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 48px;--override-icon-button-wrapper-block-size: 48px;--override-icon-button-block-size: 24px;--override-icon-button-inline-size: 24px}.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-11, var(--beacon-video-play-button-size-block-size-jumbo)) / 2);--override-icon-button-box-shadow: var(--beacon-elevation-block-end-level-1);--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--override-icon-button-color: var(--beacon-system-color-icon-primary);--override-icon-button-surface-size: calc(2 * var(--play-button-size-override));--override-icon-button-padding: var(--beacon-reference-space-4);align-self:center;display:flex;grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);justify-self:center;z-index:var(--overlay-z-index)}@media (min-width: 640px){.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-13, var(--beacon-video-play-button-size-block-size-jumbo)) / 2);--override-icon-button-padding: var(--beacon-reference-space-5)}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 64px;--override-icon-button-wrapper-block-size: 64px;--override-icon-button-block-size: 32px;--override-icon-button-inline-size: 32px}}@media (min-width: 960px){.video-play-button{--play-button-size-override: calc(var(--beacon-reference-space-15, var(--beacon-video-play-button-size-block-size-jumbo)) / 2);--override-icon-button-padding: var(--beacon-reference-space-6)}[beacon-tag-name=beacon-icon-button]::part(icon-button){--override-icon-button-wrapper-inline-size: 80px;--override-icon-button-wrapper-block-size: 80px;--override-icon-button-block-size: 40px;--override-icon-button-inline-size: 40px}}.timestamp-tag{font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));align-self:end;-webkit-backdrop-filter:blur(var(--beacon-reference-space-2, var(--beacon-unit-subatomic)));backdrop-filter:blur(var(--beacon-reference-space-2, var(--beacon-unit-subatomic)));background-color:var(--beacon-system-color-background-1, rgba(var(--beacon-color-overlay), .56));border-radius:var(--beacon-system-radius-corner-standard, var(--beacon-radii-rounded));color:var(--beacon-system-color-text-standard, var(--beacon-color-text-important-on-dark));grid-column:var(--video-overlay-column-span);grid-row:var(--video-overlay-column-span);justify-self:end;letter-spacing:var(--beacon-system-font-letter-spacing-standard);margin-block-end:var(--beacon-system-space-organism-normal, var(--beacon-video-timestamp-space-margin));margin-inline-end:var(--beacon-system-space-organism-normal, var(--beacon-video-timestamp-space-margin));padding:var(--beacon-system-space-cell-contained, var(--beacon-unit-atomic));z-index:var(--overlay-z-index)}.timestamp-tag .timestamp-container{padding-block:var(--beacon-reference-space-1, 0);padding-inline:var(--beacon-reference-space-3, var(--beacon-unit-atomic))}.hidden{display:none}.video-tag-container{display:inline-block;inline-size:min-content;position:relative}::slotted([beacon-tag-name=beacon-video-tag]){inset-block-start:var(--video-tag-inset-block-start);inset-inline-end:var(--video-tag-inset-inline-end);position:var(--video-tag-position, absolute)}::slotted([beacon-tag-name=beacon-video-tag][aspect-ratio=\"1:1\"]){--video-tag-inset-inline-end: var(--beacon-reference-space-3, var(--beacon-unit-atomic));--video-tag-inset-block-start: var(--beacon-reference-space-3, var(--beacon-unit-atomic))}::slotted([beacon-tag-name=beacon-video-tag][aspect-ratio=\"2:1\"]){--video-tag-inset-inline-end: var(--beacon-system-space-micro-normal, var(--beacon-unit-atomic));--video-tag-inset-block-start: var(--beacon-system-space-micro-normal, var(--beacon-unit-atomic))}@media (min-width: 960px){::slotted([beacon-tag-name=beacon-video-tag][aspect-ratio=\"2:1\"]){--video-tag-inset-inline-end: var(--beacon-system-space-micro-normal, var(--beacon-unit-base));--video-tag-inset-block-start: var(--beacon-system-space-micro-normal, var(--beacon-unit-base))}}::slotted(img){aspect-ratio:var(--img-aspect-ratio, initial);block-size:var(--video-tag-block-size, 100%);inline-size:var(--video-tag-inline-size, auto);object-fit:cover}:host([aspect-ratio=\"2:1\"]){--img-aspect-ratio: 2}:host([aspect-ratio=\"1:1\"]){--img-aspect-ratio: 1}\n"])));
var $ = Object.defineProperty,
  C = Object.getOwnPropertyDescriptor,
  r = function r(b, e, t, a) {
    for (var n = a > 1 ? void 0 : a ? C(e, t) : e, o = b.length - 1, c; o >= 0; o--) (c = b[o]) && (n = (a ? c(e, t, n) : c(n)) || n);
    return a && n && $(e, t, n), n;
  };
var i = /*#__PURE__*/function (_h) {
  _inherits(i, _h);
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this.beaconTagName = s.beaconTagName, _this.linkHref = "", _this.isPlaying = !1;
    return _this;
  }
  _createClass(i, [{
    key: "updateDuration",
    /**
     * Waits for the slotted brightcovePlayer to load metadata related to the slotted video,
     * and updates the duration state in hh:mm:ss format.
     * @returns a Promise that resolves after the slotted Brightcove video has fired the loadedmetadata event
     */
    value: function updateDuration() {
      var _this2 = this;
      return new Promise(function (e, t) {
        _this2.brightCovePlayer ? _this2.brightCovePlayer.on("loadedmetadata", function () {
          _this2.duration = d.formatDuration(_this2.brightCovePlayer.duration()), e(), _this2.requestUpdate();
        }) : t(new Error("Brightcove Player not loaded"));
      });
    } /** Shows or hides the play button based on playing state. */
  }, {
    key: "handlePlayButtonDisplay",
    value: function handlePlayButtonDisplay() {
      this.isPlaying = !0, m(this.isPlaying, this.playButton, s.hiddenClass);
    } /** Shows or hides the time stamp based on playing state. */
  }, {
    key: "handleTimeStampDisplay",
    value: function handleTimeStampDisplay() {
      m(this.isPlaying, this.timeStamp, s.hiddenClass);
    } /** Runs both display methods for the play button and time stamp. */
  }, {
    key: "handleVideoOverlays",
    value: function handleVideoOverlays() {
      this.handlePlayButtonDisplay(), this.handleTimeStampDisplay();
    }
    /**
     * Calls the Brightcove Player API's play() method
     */
  }, {
    key: "playSlottedVideo",
    value: function playSlottedVideo() {
      var e;
      (e = this.brightCovePlayer) == null || e.play(), this.isPlaying = !0;
    }
    /**
     * Hides the overlay content and plays the slotted video
     *  when the play button is pressed.
     */
  }, {
    key: "handlePlayButtonPress",
    value: function handlePlayButtonPress() {
      this.playSlottedVideo(), this.handleVideoOverlays();
    }
    /**
     * Attaches a `beacon-event-play` emitter to the video player's `play` event
     * in order to hide the overlays when the video is played.
     * @param videoPlayer the video player retrieved by this.BrightCovePlayer
     */
  }, {
    key: "attachPlayEventEmitter",
    value: function attachPlayEventEmitter(e) {
      var _this3 = this;
      e && e.on("play", function () {
        f(_this3.video, P.PLAY);
      });
    }
    /**
     * Applies the account number specific Brightcove player Script to the DOM
     * and awaits the load event firing from the script element.
     * @param video
     */
  }, {
    key: "applyPlayerScript",
    value: function () {
      var _applyPlayerScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var t;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!e) {
                _context3.next = 4;
                break;
              }
              t = e.getAttribute("data-account");
              _context3.next = 4;
              return d.appendPlayerScript({
                accountNum: t
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function applyPlayerScript(_x3) {
        return _applyPlayerScript.apply(this, arguments);
      }
      return applyPlayerScript;
    }()
  }, {
    key: "handleSlotChange",
    value: function () {
      var _handleSlotChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.applyPlayerScript(this.video);
            case 2:
              this.video && this.video.classList.add(s.videoClass);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleSlotChange() {
        return _handleSlotChange.apply(this, arguments);
      }
      return handleSlotChange;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this4 = this;
      var e;
      (e = this.handleDefer()) == null || e.then(function () {
        _get(_getPrototypeOf(i.prototype), "connectedCallback", _this4).call(_this4);
      });
    }
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.thumbnails.length > 0 && (this.isLink = !0);
              _context5.t0 = this.isLink;
              if (_context5.t0) {
                _context5.next = 8;
                break;
              }
              _context5.next = 5;
              return this.applyPlayerScript(this.video);
            case 5:
              _context5.next = 7;
              return this.updateDuration();
            case 7:
              this.attachPlayEventEmitter(this.brightCovePlayer);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function firstUpdated() {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }()
  }, {
    key: "render",
    value: function render() {
      return this.isLink ? u(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div class=\"video-tag-container\">\n        <slot @slotchange=", " @beacon-event-play=", "></slot>\n      </div>"])), this.handleSlotChange, this.handleVideoOverlays) : u(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", "\n\n        <time class=\"timestamp-tag\">\n          <div class=\"timestamp-container\">", "</div>\n        </time>\n\n        <slot @slotchange=", " @beacon-event-play=", "></slot>\n      "])), k(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<", " class=\"video-play-button\" label=\"Play Video\" @beacon-event-click=", "\n        >", "</", "\n      >"])), this.getScopedTag("beacon-icon-button"), this.handlePlayButtonPress, S(x), this.getScopedTag("beacon-icon-button")), this.duration, this.handleSlotChange, this.handleVideoOverlays);
    }
  }, {
    key: "brightCovePlayer",
    /**
     * getter for the global Brightcove videoJS object linked to the slotted `<video-js>` element.
     * Useable only after this.applyPlayerScript has been resolved.
     */
    get: function get() {
      if (this.video) {
        var e = this.video.getAttribute("id");
        return videojs != null ? videojs == null ? void 0 : videojs.getPlayer(e) : null;
      }
      return null;
    }
    /**
     * getter for the slotted `<video-js>` element.
     */
  }, {
    key: "video",
    get: function get() {
      return this.videos ? this.videos[0] : null;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "styles", this), j];
    }
  }, {
    key: "lightDOMStyles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "lightDOMStyles", this), L];
    }
  }]);
  return i;
}(h(z));
i.tagName = s.beaconTagName;
i.nestedComponents = s.beaconNestedComponents;
r([v({
  selector: "img",
  flatten: !0
})], i.prototype, "thumbnails", 2);
r([v({
  selector: "beacon-video-tag",
  flatten: !0
}, !0)], i.prototype, "videoTags", 2);
r([v({
  selector: "beacon-video-transcript",
  flatten: !0
}, !0)], i.prototype, "videoTranscript", 2);
r([v({
  selector: "video-js",
  flatten: !0
})], i.prototype, "videos", 2);
r([g('[beacon-tag-name="beacon-icon-button"]')], i.prototype, "playButton", 2);
r([g(".timestamp-tag")], i.prototype, "timeStamp", 2);
r([p()], i.prototype, "thumbnailURL", 2);
r([p()], i.prototype, "isLink", 2);
r([w({
  attribute: "link-href"
})], i.prototype, "linkHref", 2);
r([p()], i.prototype, "duration", 2);
r([p()], i.prototype, "isPlaying", 2);
export { i as BeaconVideo };